import { colors } from 'fitify-ui'
import { typographyStyles } from 'fitify-ui/src/typography/generated/Typography'
import styled from 'styled-components'

export const StyledSearchInput = styled.input`
  width: 100%;
  max-width: 400px;
  padding: 10px 16px;
  border: 1px solid ${colors.Gray200};
  border-radius: 100px;
  background-color: ${colors.White};
  color: ${colors.Black};
  outline: none;
  transition: border-color 100ms ease-in-out;
  ${typographyStyles('Text/Body 16')}

  &:focus {
    border-color: ${colors.Blue400};
  }

  &::placeholder {
    color: ${colors.Gray400};
  }
`
